import React from 'react'
import { ElementType, forwardRef, ImgHTMLAttributes } from 'react'
import classNames from 'classnames'

interface CardImageProps extends ImgHTMLAttributes<HTMLImageElement|HTMLOrSVGElement|HTMLOrSVGImageElement> {
    className?: string
    component?: string | ElementType
    /** Optionally position the image to the top, bottom, or make it overlay the entire card. */
    position?: 'top'|'bottom'
}

const CardImage = forwardRef<HTMLImageElement|HTMLOrSVGElement|HTMLOrSVGImageElement, CardImageProps>(({
    children,
    className,
    component: Component = 'img',
    position,
    ...otherProps
}, ref) => {

    const _className = classNames(
        {
            [`card-img-${position}`]: position,
            'card-img': !position
        },
        className
    )

    return (
        <Component
            ref={ref}
            className={_className}
            {...otherProps}>
            {children}
        </Component>
    )
})

export { CardImage }
